const englishToArabic = {
    claimed: 'تم القبول',
    requested: 'قيد الانتظار',
    delivered: 'تم التوصيل',
}
export const translateToArabic = (text) => {
    return englishToArabic[text] ?? text
}
